// ─────────────────────────────────────────────
//  OverloadFlag — supervisor staffing-overload badge (D-08)
//  Shown in a RoomCard header when a supervising doctor covers more than
//  4 rooms (rooms 5+). Dark-amber text on the pale amber tint (same pair
//  GoHomeAlert uses) so the label passes 4.5:1 — the old #f59e0b-on-tint
//  computed ~1.9:1 and was unreadable. The aria-label conveys the meaning
//  to screen readers (not color alone).
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { radius, font } = tokens;

export default function OverloadFlag({ style }) {
  return (
    <span
      aria-label="Overload: supervising more than 4 rooms"
      style={{ ...styles.badge, ...style }}
    >
      Overload
    </span>
  );
}

const styles = {
  badge: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: font.size.label,
    fontWeight: font.weight.bold,
    color: "#7a4f00",
    background: "#fef8ec",
    border: "1px solid #f59e0b",
    borderRadius: radius.full,
    padding: "2px 8px",
    whiteSpace: "nowrap",
    lineHeight: 1,
    fontFamily: font.family,
  },
};
